import { render, staticRenderFns } from "./CmsButton.vue?vue&type=template&id=a8e954e4&scoped=true"
import script from "./CmsButton.vue?vue&type=script&lang=js"
export * from "./CmsButton.vue?vue&type=script&lang=js"
import style0 from "./CmsButton.vue?vue&type=style&index=0&id=a8e954e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e954e4",
  null
  
)

export default component.exports